import { IInventoryItem } from '../../types/inventories';
import { ICommonAddress } from '../../types/shipping';
import { ITimezoneMetadata } from '../../types/timezone';

export enum OneLinkChunksEnum {
  SummaryInfo = 'summary_info',
  InventoryInfo = 'inventory_info',
  ShippingInfo = 'shipping_info',
  AdditionalInfo = 'additional_info',
  SecurityInfo = 'security_info',
  TwoFactorInfo = 'two_factor_info',
  ExperienceInfo = 'experience_info',
}

export interface IOneLinkErrors {
  [OneLinkChunksEnum.SummaryInfo]: {
    expiration_date: string;
    user_id: string;
  };
  [OneLinkChunksEnum.InventoryInfo]: {
    items: string;
    pre_created_engagement_id: string;
    pick_campaign_ids: string;
  };
  [OneLinkChunksEnum.ShippingInfo]: {
    receiver_fixed_address: string;
    org_address_ids: string;
  };
  [OneLinkChunksEnum.AdditionalInfo]: {
    on_hold_until: string;
    business_reason_id: string;
  };
  [OneLinkChunksEnum.SecurityInfo]: {
    max_submit_count: string;
  };
  [OneLinkChunksEnum.ExperienceInfo]: {
    experience_id: string;
  };
}

export interface IOLSummaryInfo {
  expiration_date: string | null;
  timezone_metadata?: ITimezoneMetadata | null;
  title: string;
  user_id: string;
}

export type TOLInventoryInfo =
  | {
      items: IInventoryItem[];
      pre_created_engagement_id: string;
      campaign_name?: string;
      pick_campaign_ids?: null;
    }
  | {
      pick_campaign_ids: string[];
      items?: null;
      pre_created_engagement_id?: null;
      campaign_name?: null;
    };

export interface IOLShippingInfo {
  is_receiver_address_fixed: boolean;
  receiver_fixed_address?: ICommonAddress;
  org_address_ids?: string[];
  is_office_dropship_enabled?: boolean;
}

export interface IOLAdditionalInfo {
  on_hold_until: string | null;
  disable_sender_email_notifications?: boolean;
  business_reason_id: string;
  internal_notes: string;
}

export interface IOLSecurityInfo {
  password: string;
  allowed_domains: string[];
  max_submit_count: number | null;
  enabled_2fa: boolean;
}

export interface IOLExperienceInfo {
  experience_id: string;
}

export type TUpdateOneLinkChunk =
  | {
      [OneLinkChunksEnum.SummaryInfo]: IOLSummaryInfo;
      [OneLinkChunksEnum.InventoryInfo]?: never;
      [OneLinkChunksEnum.ShippingInfo]?: never;
      [OneLinkChunksEnum.AdditionalInfo]?: never;
      [OneLinkChunksEnum.SecurityInfo]?: never;
      [OneLinkChunksEnum.ExperienceInfo]?: never;
    }
  | {
      [OneLinkChunksEnum.SummaryInfo]?: never;
      [OneLinkChunksEnum.InventoryInfo]: TOLInventoryInfo;
      [OneLinkChunksEnum.ShippingInfo]?: never;
      [OneLinkChunksEnum.AdditionalInfo]?: never;
      [OneLinkChunksEnum.SecurityInfo]?: never;
      [OneLinkChunksEnum.ExperienceInfo]?: never;
    }
  | {
      [OneLinkChunksEnum.SummaryInfo]?: never;
      [OneLinkChunksEnum.InventoryInfo]?: never;
      [OneLinkChunksEnum.ShippingInfo]?: IOLShippingInfo;
      [OneLinkChunksEnum.AdditionalInfo]?: never;
      [OneLinkChunksEnum.SecurityInfo]?: never;
      [OneLinkChunksEnum.ExperienceInfo]?: never;
    }
  | {
      [OneLinkChunksEnum.SummaryInfo]?: never;
      [OneLinkChunksEnum.InventoryInfo]?: never;
      [OneLinkChunksEnum.ShippingInfo]?: never;
      [OneLinkChunksEnum.AdditionalInfo]: IOLAdditionalInfo;
      [OneLinkChunksEnum.SecurityInfo]?: never;
      [OneLinkChunksEnum.ExperienceInfo]?: never;
    }
  | {
      [OneLinkChunksEnum.SummaryInfo]?: never;
      [OneLinkChunksEnum.InventoryInfo]?: never;
      [OneLinkChunksEnum.ShippingInfo]?: never;
      [OneLinkChunksEnum.AdditionalInfo]?: never;
      [OneLinkChunksEnum.SecurityInfo]: IOLSecurityInfo;
      [OneLinkChunksEnum.ExperienceInfo]?: never;
    }
  | {
      [OneLinkChunksEnum.SummaryInfo]?: never;
      [OneLinkChunksEnum.InventoryInfo]?: never;
      [OneLinkChunksEnum.ShippingInfo]?: never;
      [OneLinkChunksEnum.AdditionalInfo]?: never;
      [OneLinkChunksEnum.SecurityInfo]?: never;
      [OneLinkChunksEnum.ExperienceInfo]: IOLExperienceInfo;
    };
